/**
 * ExportLogsButton — CSV export button using encodeLogsToCsv from shared.
 */
import { encodeLogsToCsv } from '@reefapp/shared';
import type { TestLogEntry } from '@reefapp/shared';

export interface ExportLogsButtonProps {
  logs: ReadonlyArray<TestLogEntry>;
}

export function ExportLogsButton({ logs }: ExportLogsButtonProps) {
  const handleExport = () => {
    if (logs.length === 0) return;
    const csv = encodeLogsToCsv(logs);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `reefapp-test-logs-${new Date()
      .toISOString()
      .slice(0, 10)}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <button
      onClick={handleExport}
      disabled={logs.length === 0}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-semibold bg-slate-700 text-slate-200 hover:bg-slate-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      <svg
        aria-hidden="true"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
      </svg>
      Export to CSV
    </button>
  );
}
